import { render, staticRenderFns } from "./RegisterManager.vue?vue&type=template&id=a2887bce"
import script from "./RegisterManager.vue?vue&type=script&lang=js"
export * from "./RegisterManager.vue?vue&type=script&lang=js"
import style0 from "./RegisterManager.vue?vue&type=style&index=0&id=a2887bce&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports